import type { DemSkuMappingRow } from '../../types/dem';

type SkuMappingRowProps = {
  row: DemSkuMappingRow;
  selected: boolean;
  onSelect: (row: DemSkuMappingRow) => void;
  onEdit?: (row: DemSkuMappingRow) => void;
  variant?: 'full' | 'child';
};

export function SkuMappingRow({
  row,
  selected,
  onSelect,
  onEdit,
  variant = 'full',
}: SkuMappingRowProps) {
  const isChild = variant === 'child';
  const pdfDup = row.duplicatePdfText;

  return (
    <button
      type="button"
      className={`dem-sku-map-row${isChild ? ' dem-sku-map-row--child' : ''}${selected ? ' dem-sku-map-row--selected' : ''}${pdfDup ? ' dem-sku-map-row--pdf-dup' : ''}`}
      onClick={() => onSelect(row)}
      onDoubleClick={() => onEdit?.(row)}
      title={
        pdfDup
          ? 'Duplicate PDF SKU / text + System SKU pair. Double-click to edit.'
          : 'Double-click to edit'
      }
    >
      {!isChild ? (
        <span
          className={`dem-sku-map-row__pdf${pdfDup ? ' dem-sku-map-row__pdf--duplicate' : ''}`}
          title={row.pdfKey}
        >
          {row.pdfKey}
        </span>
      ) : (
        <span className="dem-sku-map-row__indent" aria-hidden />
      )}
      <span
        className={`dem-sku-map-row__sys${row.duplicateSysCode || pdfDup ? ' dem-sku-map-row__sys--duplicate' : ''}`}
        title={
          pdfDup
            ? 'Duplicate PDF SKU / text mapping for this System SKU.'
            : row.duplicateSysCode
              ? 'This System SKU maps to multiple PDF texts.'
              : undefined
        }
      >
        {row.sysCode}
      </span>
      <span className="dem-sku-map-row__factor">{row.factor}</span>
      <span className="dem-sku-map-row__uom" title={row.uom || 'No UOM stored (matches any)'}>
        {row.uom?.trim() ? row.uom : '—'}
      </span>
      <span
        className={`dem-sku-map-row__desc dem-customer-cell--clip${row.unknownSku ? ' dem-sku-map-row__desc--unknown' : ''}`}
        title={row.description}
      >
        {row.description || '—'}
      </span>
      <span
        className={`dem-sku-map-row__date${row.legacyDate ? ' dem-sku-map-row__date--legacy' : ' dem-sku-map-row__date--ok'}`}
        title={row.legacyDate ? 'Legacy mapping without date. Please verify.' : undefined}
      >
        {row.lastUsed}
      </span>
    </button>
  );
}
